import {Model, ModelMixin} from '../common/model.class';
import * as moment from 'moment';
import ProjectionInformation = Model.ProjectionInformation;
import Moment = moment.Moment;

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class DriverLicenseInfo extends ModelMixin() implements Model<DriverLicenseInfo> {

    TYPE = DriverLicenseInfo;
    static projectionInformation = new ProjectionInformation('driverLicenseInfo');

    public licenseNumber: string;
    public issuingState: string;
    public expirationDate: Moment;

    constructor(jsonData: any = {}) {
        super();
        if (jsonData.expirationDate) jsonData.expirationDate = moment(jsonData.expirationDate);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/profile/driver-license-info.model.ts